
<mat-card class="card-height-30" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxFlex="100%">
    <mat-card-content fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between center" fxLayoutAlign.lt-md="start stretch" fxFlex="100%">

        <div *ngFor="let item of [
        { key: 'totalSessionPlayed', icon: 'timer', color: 'blue', label: 'Total Session' },
         { key: 'totalDuration', icon: 'check_circle', color: 'green', label: 'Total Duration' },
        { key: 'averageDuration', icon: 'check_circle', color: 'blue', label: 'Avg Session Duration' }
      ]"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxFlex="20%" fxFlex.lt-md="100%">

            <!-- Icon -->
            <div fxLayoutAlign="center center"
                style="width: 40px; height: 40px; border-radius: 50%;"
                [ngStyle]="{
                    'background-color':
                        item.color === 'green' ? '#e8f5e9' :
                        item.color === 'red' ? '#fdecea' : '#e3f2fd'
                }">

                <mat-icon
                    [ngStyle]="{
                        'color':
                            item.color === 'green' ? '#2e7d32' :
                            item.color === 'red' ? '#c62828' : '#1565c0'
                    }">
                    {{ item.icon }}
                </mat-icon>
            </div>

            <!-- Text -->
            <div fxLayout="column" style="margin-left: 12px;">
                <div style="font-size: 20px; font-weight: 600;">
                    {{ dataList[item.key] }}{{ item.suffix || '' }}
                </div>
                <div style="font-size: 13px; color: #666;">
                    {{ item.label }}
                </div>
            </div>

        </div>

    </mat-card-content>
</mat-card>
